import { Dispatch, Middleware } from 'redux';
import type { RootState } from '../index';

const key = 'tef-coms-state';

export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem(key);
    if (!serializedState) return undefined;
    const state = JSON.parse(serializedState) as RootState;
    // TODO: Refactor loading of state from session-storage
    // Reset some values for processing reasons...
    const { config, auth, consents } = state;
    auth.error = false;
    consents.error = false;
    config.error = false;
    config.occlThemeLoaded = false;
    config.occlVendorsLoaded = false;
    config.occlBundleLoaded = false;
    config.occlReady = false;
    return state;
    // eslint-disable-next-line sonarjs/no-ignored-exceptions
  } catch (_err) {
    return undefined;
  }
};

export const saveState = (state: RootState) => {
  const serializedState = JSON.stringify(state);
  sessionStorage.setItem(key, serializedState);
};

const persist: Middleware<unknown, RootState> = ({ getState }) => (next) => (action) => {
  const value = next(action) as Dispatch;
  const state = getState();
  saveState(state);
  return value;
};

// redux middleware
export default persist;
